import { useQuery } from '@tanstack/react-query'

import { getDocument } from '@/domains/document'

/** the company logo in the sidebar header. resolves the logo document to a
 * presigned url (cached). falls back to the TandemOne mark until a logo is
 * set. shared by OnboardingShell and AppShell so both sidebars render the
 * same active-company avatar.
 */
export function CompanyLogo({
  logoId,
  name
}: {
  logoId: string | null
  name: string
}) {
  const { data } = useQuery({
    queryKey: ['document', logoId],
    queryFn: ({ signal }) => getDocument(logoId!, signal),
    enabled: Boolean(logoId),
    staleTime: 60_000
  })

  if (logoId && data) {
    return (
      <img
        src={data.downloadUrl}
        alt={name}
        className='size-8 rounded-lg object-cover'
      />
    )
  }

  return (
    <img src='/favicon.ico' alt='TandemOne' className='size-8 rounded-lg' />
  )
}
